import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialogModule,
} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: 'app-timeout-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './timeout-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './timeout-dialog.component.css'
})
export class TimeoutDialogComponent {
}
